import { render } from "./ShiftLoad.vue?vue&type=template&id=c669ea62&lang=true"
import script from "./ShiftLoad.vue?vue&type=script&lang=js"
export * from "./ShiftLoad.vue?vue&type=script&lang=js"

import "./ShiftLoad.vue?vue&type=style&index=0&id=c669ea62&lang=scss"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__